"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The version of the Jupyter controls widget attribute spec that this package
 * implements.
 */
exports.JUPYTER_CONTROLS_VERSION = '1.1.0';
